(function () {
  function initCaNubeBoard() {
    if (window.__caNubeBoardReadyVersion === 'mobile-board-v1') return;
    window.__caNubeBoardReadyVersion = 'mobile-board-v1';

    const state = {
      x: 1,
      y: 0,
      sectionScroll: 0,
      dragging: false,
      animating: false,
      renderQueued: false,
      panning: false
    };

    const themes = {
      '0,0': ['#EDE4D1', '#41231D'],
      '1,0': ['#E66B4A', '#EDE4D1'],
      '1,1': ['#EDE4D1', '#41231D'],
      '1,2': ['#1A1F36', '#EDE4D1'],
      '2,0': ['#D1D1E9', '#1A1F36'],
      '2,1': ['#FCC6C5', '#A14058'],
      '2,2': ['#1A1F36', '#EDE4D1'],
      '2,3': ['#F7C3A3', '#41231D'],
      '2,4': ['#FCC6C5', '#A14058'],
      '2,5': ['#41231D', '#EDE4D1'],
      '2,6': ['#B39342', '#41231D'],
      '3,0': ['#8779C7', '#EDE4D1']
    };

    const layout = {
      viewportW: window.innerWidth,
      viewportH: window.innerHeight,
      cells: [],
      columns: new Map()
    };

    let animTimer = null;
    let panTimer = null;
    let wheelLock = false;
    let resizeTimer = null;
    let lastRenderedOffsetY = null;
    let lastRenderedOffsetX = null;
    let mobileSyncQueued = false;
    let mobileBoard = null;
    let mobileItems = [];
    let mobileControls = null;
    let mobileNavigationLocked = false;
    let mobileNavigationTimer = null;
    let mobileNavigationSettleTimer = null;
    let routeReconcileTimer = null;
    let motionObserver = null;
    let lastRouteHash = '';
    let horizontalGestureTotal = 0;
    let horizontalGestureTimer = null;
    let horizontalHint = null;
    let horizontalHintTimer = null;
    let horizontalHintAnimationTimer = null;
    let horizontalHintUniverse = null;
    let verticalHint = null;
    let verticalHintTimer = null;
    let verticalHintAnimationTimer = null;
    let verticalHintUniverse = null;

    const primaryColumns = [1, 2];
    const horizontalHintPalette = {
      1: {
        cloud: 'var(--ca-nube-lilac)',
        arrow: 'var(--ca-nube-ember)'
      },
      2: {
        cloud: 'var(--ca-nube-ember)',
        arrow: 'var(--ca-nube-cream)'
      }
    };

    const routeEntries = [
      ['inicio', 1, 0],
      ['marca', 1, 1],
      ['momentos', 1, 2],
      ['chia', 2, 0],
      ['cuando', 2, 1],
      ['ingredientes', 2, 2],
      ['preparacion', 2, 3],
      ['recetas', 2, 4],
      ['comparativa', 2, 5],
      ['comprar', 2, 6]
    ];

    const mobileQuery = window.matchMedia('(max-width: 900px)');
    const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    function isCartDrawerInteraction(event) {
      const target = event?.target instanceof Element ? event.target : null;
      return Boolean(document.querySelector('cart-drawer.active') || target?.closest('cart-drawer'));
    }

    function initMotionLayer() {
      if (reduceMotionQuery.matches) return;
      document.documentElement.classList.add('ca-motion-ready');

      const revealSelectors = [
        '.ca-nube-copy',
        '.ca-nube-card',
        '.ca-nube-sabor-card',
        '.ca-nube-img-slot',
        '.ca-nube-compare-intro',
        '.ca-nube-compare-tabs',
        '.ca-nube-compare-row',
        '.ca-nube-como__line',
        '.ca-nube-como__step',
        '.ca-nube-ingredient-row',
        '.ca-nube-fact',
        '.ca-nube-jammy-copy',
        '.ca-nube-jammy-ingredients__item',
        '.ca-nube-jammy-vibe__copy',
        '.ca-nube-jammy-vibe__photo',
        '.ca-nube-jammy-waitlist__copy',
        '.ca-nube-jammy-waitlist__form-card',
        '.ca-nube-cierre__actions',
        '.ca-nube-cierre__signup',
        '.ca-nube-cierre__meta',
        '.ca-nube-contact__panel'
      ].join(',');

      if (!motionObserver) {
        motionObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            motionObserver.unobserve(entry.target);
          });
        }, { threshold: 0.08, rootMargin: '0px 0px 12% 0px' });
      }

      const sectionCounts = new Map();
      Array.from(document.querySelectorAll(revealSelectors)).forEach((node) => {
        if (node.classList.contains('ca-motion-item')) return;
        node.classList.add('ca-motion-item');
        const section = node.closest('.ca-nube-cell') || document.body;
        const sectionIndex = sectionCounts.get(section) || 0;
        sectionCounts.set(section, sectionIndex + 1);
        const delayStep = isMobileBoard() ? 14 : 16;
        const delayMax = isMobileBoard() ? 70 : 80;
        node.style.setProperty('--ca-motion-delay', `${Math.min(sectionIndex * delayStep, delayMax)}ms`);
        motionObserver.observe(node);
      });

      Array.from(document.querySelectorAll('.ca-nube-cloud, [data-ca-decor]')).forEach((node, index) => {
        node.classList.add('ca-motion-parallax');
        node.style.setProperty('--ca-motion-depth', String(0.55 + (index % 4) * 0.18));
      });
    }

    function updateMotionParallax() {
      if (reduceMotionQuery.matches) return;
      const offsetY = activeOffset();
      document.querySelectorAll('.ca-motion-parallax').forEach((node) => {
        const cell = node.closest('.ca-nube-cell');
        const meta = layout.cells.find((item) => item.cell === cell);
        if (!meta) return;
        const depth = Number(node.style.getPropertyValue('--ca-motion-depth')) || 0.75;
        const x = clamp((state.x - meta.x) * 8 * depth, -14, 14);
        const y = clamp(((offsetY - meta.start) / Math.max(layout.viewportH, 1)) * 12 * depth, -18, 18);
        node.style.setProperty('--ca-motion-x', `${x.toFixed(2)}px`);
        node.style.setProperty('--ca-motion-y', `${y.toFixed(2)}px`);
      });
    }

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function parseCssLength(value) {
      const raw = String(value || '').trim();
      if (!raw || raw === 'auto') return null;

      const probe = document.createElement('div');
      probe.style.position = 'absolute';
      probe.style.visibility = 'hidden';
      probe.style.pointerEvents = 'none';
      probe.style.height = raw;
      probe.style.width = '0';
      document.body.appendChild(probe);
      const height = probe.getBoundingClientRect().height;
      probe.remove();

      return Number.isFinite(height) && height > 0 ? height : null;
    }

    function measureAutoHeight(cell) {
      const previousHeight = cell.style.getPropertyValue('--ca-cell-height');
      cell.style.setProperty('--ca-cell-height', `${layout.viewportH}px`);

      const cellRect = cell.getBoundingClientRect();
      const measuredNodes = Array.from(cell.querySelectorAll('*')).filter((node) => (
        !node.closest('.ca-nube-cloud, [data-ca-decor], .ca-nube-section-nav') &&
        window.getComputedStyle(node).display !== 'none'
      ));

      const contentBottom = measuredNodes.reduce((max, node) => {
        const rect = node.getBoundingClientRect();
        return Math.max(max, rect.bottom - cellRect.top);
      }, 0);

      if (previousHeight) {
        cell.style.setProperty('--ca-cell-height', previousHeight);
      } else {
        cell.style.removeProperty('--ca-cell-height');
      }

      if (contentBottom <= layout.viewportH + 1) return layout.viewportH;

      return Math.ceil(contentBottom + 48);
    }

    function sectionHeight(cell) {
      const styles = window.getComputedStyle(cell);
      const declared = cell.dataset.sectionHeight || styles.getPropertyValue('--section-height');
      const cleanDeclared = String(declared || '').trim();

      if (cleanDeclared === 'auto' || cell.classList.contains('ca-nube-cell--scroll')) {
        return measureAutoHeight(cell);
      }

      const parsed = parseCssLength(cleanDeclared);
      if (parsed) return Math.max(layout.viewportH, Math.ceil(parsed));

      return measureAutoHeight(cell);
    }

    function sectionEntryOffset(cell, height) {
      const styles = window.getComputedStyle(cell);
      const declared = cell.dataset.sectionEntryOffset || styles.getPropertyValue('--section-entry-offset');
      const parsed = parseCssLength(declared);
      const maxScroll = Math.max(0, height - layout.viewportH);
      return clamp(parsed || 0, 0, maxScroll);
    }

    function isMobileBoard() {
      return mobileQuery.matches;
    }

    function usesNativeBoard() {
      return true;
    }

    function routeFor(x, y) {
      return routeEntries.find((entry) => entry[1] === Math.round(x) && entry[2] === Math.round(y)) || null;
    }

    function routeFromHash() {
      const hash = decodeURIComponent(window.location.hash.replace(/^#/, '')).toLowerCase();
      return routeEntries.find((entry) => entry[0] === hash) || null;
    }

    function writeRoute(x, y, mode = 'replace') {
      if (window.location.hash === '#contacto') return;
      const route = routeFor(x, y);
      if (!route) return;
      const nextHash = `#${route[0]}`;
      if (mode === 'push' && nextHash === window.location.hash) return;
      if (mode === 'replace' && nextHash === lastRouteHash) return;
      const method = mode === 'push' ? 'pushState' : 'replaceState';
      window.history[method]({ caNubeRoute: route[0] }, '', nextHash);
      lastRouteHash = nextHash;
    }

    function updateHudState() {
      const x = Math.round(state.x);
      const y = Math.round(state.y);
      const activeKey = x === 2 ? 'products' : (x === 1 && y > 0 ? 'brand' : (x === 1 ? 'home' : ''));
      document.querySelectorAll('[data-ca-nav-section]').forEach((item) => {
        const active = item.dataset.caNavSection === activeKey;
        item.classList.toggle('is-active', active);
        if (active) {
          item.setAttribute('aria-current', 'page');
        } else {
          item.removeAttribute('aria-current');
        }
      });
    }

    function updateColumnAccessibility(activeColumn) {
      if (!mobileBoard) return;
      mobileBoard.querySelectorAll('[data-ca-mobile-column]').forEach((column) => {
        const active = column === activeColumn;
        column.inert = !active;
        column.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    }

    function focusSection(x, y) {
      const meta = metaFor(x, y);
      const heading = meta?.cell.querySelector('h1, h2');
      if (!heading) return;
      if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
    }

    function sectionYForColumn(column) {
      if (!column) return 0;
      const probeY = column.scrollTop + mobileThemeProbeOffset();
      const wrapper = Array.from(column.children).find((item) => (
        probeY >= item.offsetTop && probeY < item.offsetTop + item.offsetHeight
      ));
      const cell = wrapper?.matches?.('.ca-nube-cell')
        ? wrapper
        : wrapper?.querySelector('.ca-nube-cell');
      return cell ? Number(cell.dataset.y || 0) : 0;
    }

    function ensureHorizontalHint() {
      if (horizontalHint) return horizontalHint;
      horizontalHint = document.createElement('button');
      horizontalHint.type = 'button';
      horizontalHint.disabled = true;
      horizontalHint.className = 'ca-nube-horizontal-hint';
      horizontalHint.setAttribute('aria-label', 'ir al universo de productos');
      horizontalHint.innerHTML = [
        '<span class="ca-nube-horizontal-hint__cloud" aria-hidden="true">',
        '  <svg class="ca-nube-hint-arrow" viewBox="0 0 40 40" focusable="false">',
        '    <path d="M8 20 C15 20 22 20 31 20 M22 11 C24.5 14.5 28 18 31 20 C28 22 24.5 25.5 22 29" />',
        '  </svg>',
        '</span>'
      ].join('');
      horizontalHint.addEventListener('click', () => {
        const x = Math.round(state.x);
        const direction = horizontalHint.classList.contains('is-right') ? 1 : -1;
        const targetX = primaryColumnTarget(x, direction);
        if (targetX === null) return;
        go(targetX, 0, { focus: true, preserveScroll: true });
      });
      document.body.appendChild(horizontalHint);
      return horizontalHint;
    }

    function hideHintImmediately(hint) {
      if (!hint) return;
      hint.classList.add('is-navigation-hidden');
      window.requestAnimationFrame(() => {
        hint?.classList.remove('is-navigation-hidden');
      });
    }

    function hideHorizontalHint(immediate = false) {
      window.clearTimeout(horizontalHintTimer);
      window.clearTimeout(horizontalHintAnimationTimer);
      horizontalHintTimer = null;
      horizontalHintAnimationTimer = null;
      if (horizontalHint) {
        if (immediate) hideHintImmediately(horizontalHint);
        horizontalHint.disabled = true;
        horizontalHint.classList.remove('is-active', 'is-breathing', 'is-left', 'is-right');
      }
      horizontalHintUniverse = null;
    }

    function scheduleHorizontalHint() {
      if (isMobileBoard() || document.querySelector('[data-ca-contact-overlay].is-open')) {
        hideHorizontalHint();
        return;
      }

      const x = Math.round(state.x);
      const currentColumn = mobileBoard?.querySelector(`[data-ca-mobile-column="${x}"]`);
      const atUniverseStart = Math.round(state.y) === 0 && (currentColumn?.scrollTop || 0) <= 4;
      if (!atUniverseStart) {
        hideHorizontalHint(true);
        return;
      }

      const direction = x === primaryColumns[0] ? 1 : (x === primaryColumns[primaryColumns.length - 1] ? -1 : 0);
      const targetX = primaryColumnTarget(x, direction);
      if (!direction || targetX === null) {
        hideHorizontalHint();
        return;
      }

      const palette = horizontalHintPalette[x];
      if (!palette) {
        hideHorizontalHint();
        return;
      }

      const hint = ensureHorizontalHint();
      hint.style.setProperty('--ca-hint-cloud-color', palette.cloud);
      hint.style.setProperty('--ca-hint-arrow-color', palette.arrow);
      hint.setAttribute(
        'aria-label',
        direction > 0 ? 'ir al universo de productos' : 'volver al universo de marca'
      );
      hint.dataset.caCloudDestination = direction > 0 ? 'productos' : 'marca';

      if (horizontalHintUniverse === x && (horizontalHintTimer || hint.classList.contains('is-active'))) return;

      hideHorizontalHint();
      horizontalHintUniverse = x;
      const activeColumn = mobileBoard?.querySelector(`[data-ca-mobile-column="${x}"]`);
      const isSettled = !activeColumn || Math.abs(mobileBoard.scrollLeft - mobileColumnOffset(activeColumn)) <= 8;
      if (isMobileBoard() || mobileNavigationLocked || Math.round(state.x) !== x || !isSettled) {
        hideHorizontalHint();
        return;
      }

      hint.disabled = false;
      hint.classList.add('is-active', direction > 0 ? 'is-right' : 'is-left');
      window.requestAnimationFrame(() => hint.classList.add('is-breathing'));
      horizontalHintAnimationTimer = window.setTimeout(() => {
        horizontalHintAnimationTimer = null;
        hint.classList.remove('is-breathing');
      }, 1500);
    }

    function ensureVerticalHint() {
      if (verticalHint) return verticalHint;
      verticalHint = document.createElement('button');
      verticalHint.type = 'button';
      verticalHint.disabled = true;
      verticalHint.className = 'ca-nube-vertical-hint';
      verticalHint.setAttribute('aria-label', 'ir a la siguiente sección');
      verticalHint.innerHTML = [
        '<span class="ca-nube-vertical-hint__cloud" aria-hidden="true">',
        '  <svg class="ca-nube-hint-arrow" viewBox="0 0 40 40" focusable="false">',
        '    <path d="M8 20 C15 20 22 20 31 20 M22 11 C24.5 14.5 28 18 31 20 C28 22 24.5 25.5 22 29" />',
        '  </svg>',
        '</span>'
      ].join('');
      verticalHint.addEventListener('click', () => {
        const x = Math.round(state.x);
        if (!canGoDown(x, 0)) return;
        go(x, 1, { focus: true });
      });
      document.body.appendChild(verticalHint);
      return verticalHint;
    }

    function hideVerticalHint(immediate = false) {
      window.clearTimeout(verticalHintTimer);
      window.clearTimeout(verticalHintAnimationTimer);
      verticalHintTimer = null;
      verticalHintAnimationTimer = null;

      if (verticalHint) {
        if (immediate) hideHintImmediately(verticalHint);
        verticalHint.disabled = true;
        verticalHint.classList.remove('is-active', 'is-breathing');
      }
      verticalHintUniverse = null;
    }

    function scheduleVerticalHint() {
      if (isMobileBoard() || document.querySelector('[data-ca-contact-overlay].is-open')) {
        hideVerticalHint();
        return;
      }

      const x = Math.round(state.x);
      const y = Math.round(state.y);
      if (x === 2) {
        hideVerticalHint(true);
        return;
      }

      const column = mobileBoard?.querySelector(`[data-ca-mobile-column="${x}"]`);
      const nextMeta = metaFor(x, 1);
      const atUniverseStart = y === 0 && (column?.scrollTop || 0) <= 4;

      if (!atUniverseStart || !nextMeta) {
        hideVerticalHint();
        return;
      }

      if (verticalHintUniverse === x && (verticalHintTimer || verticalHint?.classList.contains('is-active'))) return;

      hideVerticalHint();
      verticalHintUniverse = x;
      const hint = ensureVerticalHint();
      hint.dataset.caCloudDestination = x === 1 ? 'conócenos' : 'ingredientes';
      hint.setAttribute('aria-label', x === 1 ? 'conócenos: ir a la sección de marca' : 'ir a los ingredientes');
      const marquee = x === 2 ? metaFor(x, 0)?.cell.querySelector('.ca-nube-sabores-marquee') : null;
      const marqueeTop = marquee ? marquee.getBoundingClientRect().top : window.innerHeight;
      hint.style.setProperty('--ca-hint-cloud-color', 'var(--ca-nube-cream)');
      hint.style.setProperty('--ca-hint-arrow-color', 'var(--ca-nube-ember)');
      hint.style.setProperty('--ca-vertical-hint-bottom', `${marquee ? Math.max(0, Math.ceil(window.innerHeight - marqueeTop)) : 0}px`);
      hint.classList.toggle('is-product-start', x === 2);

      if (
        mobileNavigationLocked ||
        Math.round(state.x) !== x ||
        Math.round(state.y) !== 0 ||
        (column?.scrollTop || 0) > 4
      ) {
        hideVerticalHint();
        return;
      }

      hint.disabled = false;
      hint.classList.add('is-active');
      window.requestAnimationFrame(() => hint.classList.add('is-breathing'));
      verticalHintAnimationTimer = window.setTimeout(() => {
        verticalHintAnimationTimer = null;
        hint.classList.remove('is-breathing');
      }, 1500);
    }

    function primaryColumnTarget(x, direction) {
      const currentIndex = primaryColumns.indexOf(Math.round(x));
      if (currentIndex < 0) return direction < 0 ? primaryColumns[primaryColumns.length - 1] : null;
      return primaryColumns[currentIndex + direction] ?? null;
    }

    function cellWrapper(cell) {
      return cell.closest('.shopify-section') || cell;
    }

    function setupMobileBoard(positionAfterBuild = true) {
      const cells = Array.from(document.querySelectorAll('.ca-nube-cell'));
      if (!cells.length) return;

      if (positionAfterBuild) {
        mobileNavigationLocked = true;
        window.clearTimeout(mobileNavigationTimer);
      }

      document.documentElement.classList.add('ca-nube-mobile-board-active');
      document.documentElement.style.setProperty('--ca-nav-x', state.x);
      document.documentElement.style.setProperty('--ca-nav-y', state.y);

      if (!mobileItems.length) {
        mobileItems = cells.map((cell) => {
          const wrapper = cellWrapper(cell);
          return {
            cell,
            wrapper,
            parent: wrapper.parentNode,
            next: wrapper.nextSibling,
            x: Number(cell.dataset.x || 0),
            y: Number(cell.dataset.y || 0)
          };
        });
      }

      if (!mobileBoard) {
        mobileBoard = document.createElement('div');
        mobileBoard.className = 'ca-nube-mobile-board';
        mobileBoard.setAttribute('data-ca-mobile-board', '');
        mobileItems[0].parent.insertBefore(mobileBoard, mobileItems[0].wrapper);
        mobileBoard.addEventListener('scroll', () => {
          if (!isMobileBoard()) {
            hideHorizontalHint(true);
            hideVerticalHint(true);
          }
          queueMobileNavigationSettle();
          queueMobileStateSync();
        }, { passive: true });
      }

      setupMobileControls();

      const columns = new Map();
      mobileItems.forEach((item) => {
        if (!columns.has(item.x)) {
          const selector = `[data-ca-mobile-column="${item.x}"]`;
          const column = mobileBoard?.querySelector(selector) || document.createElement('div');
          column.className = 'ca-nube-mobile-column';
          column.dataset.caMobileColumn = String(item.x);
          columns.set(item.x, column);
        }
      });

      Array.from(columns.keys()).sort((a, b) => a - b).forEach((x) => {
        const column = columns.get(x);
        if (!column.parentNode) {
          mobileBoard.appendChild(column);
          column.addEventListener('scroll', () => {
            const x = Number(column.dataset.caMobileColumn || 0);
            if (!isMobileBoard() && Math.round(state.x) === x && column.scrollTop > 4) {
              hideHorizontalHint(true);
              hideVerticalHint(true);
            }
            queueMobileNavigationSettle();
            queueMobileStateSync();
          }, { passive: true });
        }
      });

      mobileItems
        .slice()
        .sort((a, b) => (a.x - b.x) || (a.y - b.y))
        .forEach((item) => {
          const column = columns.get(item.x);
          item.wrapper.style.setProperty('--ca-mobile-y', item.y);
          column.appendChild(item.wrapper);
        });

      if (positionAfterBuild) {
        // Position the board in the same task that creates its columns.
        mobileGo(state.x, state.y, false);
        window.requestAnimationFrame(syncMobileState);
        scheduleHorizontalHint();
      }
    }

    function queueMobileStateSync() {
      if (mobileSyncQueued) return;
      mobileSyncQueued = true;
      window.requestAnimationFrame(() => {
        mobileSyncQueued = false;
        syncMobileState();
      });
    }

    function setupMobileControls() {
      if (mobileControls) return;

      mobileControls = document.createElement('div');
      mobileControls.className = 'ca-nube-mobile-controls';
      mobileControls.innerHTML = [
        '<button class="ca-nube-mobile-control ca-nube-mobile-control--prev" type="button" data-ca-mobile-prev aria-label="ir a la columna anterior"></button>',
        '<button class="ca-nube-mobile-control ca-nube-mobile-control--next" type="button" data-ca-mobile-next aria-label="ir a la columna siguiente"></button>'
      ].join('');
      document.body.appendChild(mobileControls);

      mobileControls.addEventListener('click', (event) => {
        const prev = event.target.closest('[data-ca-mobile-prev]');
        const next = event.target.closest('[data-ca-mobile-next]');
        if (!prev && !next) return;

        const direction = next ? 1 : -1;
        const target = primaryColumnTarget(state.x, direction);
        if (target !== null) go(target, 0, { focus: true });
      });

      updateMobileControls();
    }

    function updateMobileControls() {
      if (!mobileControls) return;
      const x = Math.round(state.x);
      const prev = mobileControls.querySelector('[data-ca-mobile-prev]');
      const next = mobileControls.querySelector('[data-ca-mobile-next]');
      if (prev) {
        prev.disabled = primaryColumnTarget(x, -1) === null;
        prev.setAttribute('aria-label', 'volver a marca');
      }
      if (next) {
        next.disabled = primaryColumnTarget(x, 1) === null;
        next.setAttribute('aria-label', 'ir a productos');
      }
    }

    function mobileThemeProbeOffset() {
      const hud = document.querySelector('.ca-nube-hud');
      const rect = hud?.getBoundingClientRect();
      return Math.max(0, Math.ceil(rect?.bottom || 112) + 2);
    }

    function mobileColumnOffset(column) {
      if (!mobileBoard || !column) return 0;
      const columns = Array.from(mobileBoard.querySelectorAll('[data-ca-mobile-column]'));
      const index = columns.indexOf(column);
      return Math.max(0, index) * (mobileBoard.clientWidth || window.innerWidth);
    }

    function finishMobileNavigation() {
      if (!mobileNavigationLocked) return;
      window.clearTimeout(mobileNavigationTimer);
      window.clearTimeout(mobileNavigationSettleTimer);
      mobileNavigationTimer = null;
      mobileNavigationSettleTimer = null;
      mobileBoard?.classList.remove('is-programmatic-navigation');
      mobileNavigationLocked = false;
      syncMobileState();
    }

    function queueMobileNavigationSettle() {
      if (!mobileNavigationLocked) return;
      window.clearTimeout(mobileNavigationSettleTimer);
      mobileNavigationSettleTimer = window.setTimeout(finishMobileNavigation, 72);
    }

    function syncMobileState() {
      if (!mobileBoard || mobileNavigationLocked) return;
      const columns = Array.from(mobileBoard.querySelectorAll('[data-ca-mobile-column]'));
      const activeColumn = columns.reduce((closest, column) => {
        const distance = Math.abs(mobileColumnOffset(column) - mobileBoard.scrollLeft);
        return !closest || distance < closest.distance ? { column, distance } : closest;
      }, null);

      if (!activeColumn?.column) return;

      const columnWidth = mobileBoard.clientWidth || window.innerWidth;
      const settleThreshold = Math.min(16, columnWidth * 0.04);
      if (activeColumn.distance > settleThreshold) return;

      const x = Number(activeColumn.column.dataset.caMobileColumn || 0);
      const sectionWrappers = Array.from(activeColumn.column.children);
      const probeY = activeColumn.column.scrollTop + mobileThemeProbeOffset();
      const activeWrapper = sectionWrappers.find((wrapper) => (
        probeY >= wrapper.offsetTop && probeY < wrapper.offsetTop + wrapper.offsetHeight
      )) || sectionWrappers.reduce((closest, wrapper) => {
        if (wrapper.offsetTop > probeY) return closest;
        return !closest || wrapper.offsetTop > closest.offsetTop ? wrapper : closest;
      }, null);
      const activeCell = activeWrapper?.matches?.('.ca-nube-cell')
        ? activeWrapper
        : activeWrapper?.querySelector('.ca-nube-cell');
      const y = activeCell ? Number(activeCell.dataset.y || 0) : 0;
      state.x = x;
      state.y = y;
      state.sectionScroll = activeColumn.column.scrollTop;
      document.documentElement.style.setProperty('--ca-nav-x', state.x);
      document.documentElement.style.setProperty('--ca-nav-y', state.y);
      setTheme();
      updateMobileControls();
      updateHudState();
      updateColumnAccessibility(activeColumn.column);
      writeRoute(state.x, state.y, 'replace');
      scheduleHorizontalHint();
      scheduleVerticalHint();
    }

    function teardownMobileBoard() {
      if (!mobileBoard) return;

      mobileItems.forEach((item) => {
        item.wrapper.style.removeProperty('--ca-mobile-y');
        if (item.next && item.next.parentNode === item.parent) {
          item.parent.insertBefore(item.wrapper, item.next);
        } else {
          item.parent.appendChild(item.wrapper);
        }
      });

      mobileBoard.remove();
      mobileBoard = null;
      document.documentElement.classList.remove('ca-nube-mobile-board-active');
    }

    function mobileGo(x, y, smooth = true, options = {}) {
      if (!primaryColumns.includes(Math.round(x))) return;
      setupMobileBoard(false);
      if (!mobileBoard) return;

      const originX = Math.round(state.x);
      const originY = Math.round(state.y);
      const targetX = Math.max(minX(), Math.min(maxX(), Math.round(x)));
      let targetY = Math.max(0, Math.min(maxY(targetX), Math.round(y)));
      const column = mobileBoard.querySelector(`[data-ca-mobile-column="${targetX}"]`);
      if (options.preserveScroll && column) {
        targetY = sectionYForColumn(column);
      }
      const meta = metaFor(targetX, targetY) || metaFor(targetX, 0);
      const wrapper = meta ? cellWrapper(meta.cell) : null;
      const behavior = smooth && !reduceMotionQuery.matches ? 'smooth' : 'instant';

      if (targetX !== originX) {
        hideHorizontalHint(true);
        hideVerticalHint(true);
      } else if (targetY !== originY) {
        hideHorizontalHint(true);
        hideVerticalHint(true);
      }

      state.x = targetX;
      state.y = targetY;
      state.sectionScroll = options.preserveScroll && column ? column.scrollTop : 0;
      mobileNavigationLocked = true;
      window.clearTimeout(mobileNavigationTimer);
      window.clearTimeout(mobileNavigationSettleTimer);
      mobileBoard.classList.add('is-programmatic-navigation');

      document.documentElement.style.setProperty('--ca-nav-x', state.x);
      document.documentElement.style.setProperty('--ca-nav-y', state.y);

      if (column) {
        updateColumnAccessibility(column);
        if (smooth) {
          mobileBoard.scrollTo({
            left: mobileColumnOffset(column),
            behavior
          });
        } else {
          const targetLeft = mobileColumnOffset(column);
          mobileBoard.scrollTo({ left: targetLeft, behavior: 'instant' });
        }
        if (wrapper && !options.preserveScroll) {
          column.scrollTo({ top: wrapper.offsetTop, behavior });
          if (targetX === 2 && targetY === 0) window.caNubeRestoreCatalog?.(column);
        }
      }

      setTheme();
      updateMobileControls();
      updateHudState();
      if (column && targetX === 2 && targetY === 0) {
        clearTimeout(window.caCatalogBootTimeout);
        document.documentElement.classList.remove('ca-catalog-boot');
      }

      if (options.historyMode) {
        writeRoute(targetX, targetY, options.historyMode);
      }
      if (options.focus) {
        window.setTimeout(() => focusSection(targetX, targetY), smooth && !reduceMotionQuery.matches ? 660 : 0);
      }

      mobileNavigationTimer = window.setTimeout(
        finishMobileNavigation,
        smooth && !reduceMotionQuery.matches ? 660 : 32
      );
    }

    function buildLayout() {
      if (usesNativeBoard()) {
        layout.viewportW = window.innerWidth;
        layout.viewportH = window.innerHeight;
        layout.cells = Array.from(document.querySelectorAll('.ca-nube-cell')).map((cell) => ({
          cell,
          x: Number(cell.dataset.x || 0),
          y: Number(cell.dataset.y || 0),
          height: Math.max(layout.viewportH, cell.scrollHeight),
          entryOffset: 0,
          start: 0
        }));

        layout.columns = new Map();
        layout.cells.forEach((meta) => {
          if (!layout.columns.has(meta.x)) layout.columns.set(meta.x, []);
          layout.columns.get(meta.x).push(meta);
        });
        layout.columns.forEach((column) => column.sort((a, b) => a.y - b.y));

        clampState();
        setupMobileBoard();
        initMotionLayer();
        updateMotionParallax();
        return;
      }

      teardownMobileBoard();
      layout.viewportW = window.innerWidth;
      layout.viewportH = window.innerHeight;
      layout.cells = Array.from(document.querySelectorAll('.ca-nube-cell')).map((cell) => {
        const height = sectionHeight(cell);
        return {
          cell,
          x: Number(cell.dataset.x || 0),
          y: Number(cell.dataset.y || 0),
          height,
          entryOffset: sectionEntryOffset(cell, height),
          start: 0
        };
      });

      layout.columns = new Map();
      layout.cells.forEach((meta) => {
        if (!layout.columns.has(meta.x)) layout.columns.set(meta.x, []);
        layout.columns.get(meta.x).push(meta);
      });

      layout.columns.forEach((column) => {
        let offset = 0;
        column.sort((a, b) => a.y - b.y).forEach((meta) => {
          meta.start = offset;
          offset += meta.height;
        });
      });

      clampState();
      initMotionLayer();
      render();
    }

    function columnFor(x) {
      return layout.columns.get(Math.round(x)) || [];
    }

    function metaFor(x, y) {
      return columnFor(x).find((meta) => meta.y === Math.round(y)) || null;
    }

    function activeMeta() {
      return metaFor(state.x, state.y);
    }

    function maxX() {
      const values = Array.from(layout.columns.keys());
      return values.length ? Math.max(...values) : 0;
    }

    function minX() {
      const values = Array.from(layout.columns.keys());
      return values.length ? Math.min(...values) : 0;
    }

    function maxY(x) {
      const column = columnFor(x);
      return column.length ? Math.max(...column.map((meta) => meta.y)) : 0;
    }

    function canGoRight(x, y) { return y === 0 && x < maxX(); }
    function canGoLeft(x, y) { return y === 0 && x > minX(); }
    function canGoDown(x, y) { return y < maxY(x); }
    function canGoUp(x, y) { return y > 0; }

    function clampState() {
      state.x = clamp(Math.round(state.x), minX(), maxX());
      state.y = clamp(Math.round(state.y), 0, maxY(state.x));
      if (!activeMeta()) state.y = 0;

      const meta = activeMeta();
      const maxScroll = meta ? Math.max(0, meta.height - layout.viewportH) : 0;
      if (meta && state.sectionScroll === 0 && meta.entryOffset > 0) {
        state.sectionScroll = meta.entryOffset;
      }
      state.sectionScroll = clamp(state.sectionScroll, 0, maxScroll);
    }

    function activeOffset() {
      const meta = activeMeta();
      return meta ? meta.start + state.sectionScroll : 0;
    }

    function defaultSectionScroll(x, y) {
      const meta = metaFor(x, y);
      return meta ? meta.entryOffset : 0;
    }

    function setTheme() {
      const key = Math.round(state.x) + ',' + Math.round(state.y);
      const theme = themes[key] || themes['1,0'];
      const meta = activeMeta();
      const styles = meta ? window.getComputedStyle(meta.cell) : null;
      const bg = styles?.getPropertyValue('--cell-bg').trim() || theme[0];
      const fg = styles?.getPropertyValue('--cell-fg').trim() || theme[1];
      document.documentElement.style.setProperty('--ca-current-bg', bg);
      document.documentElement.style.setProperty('--ca-current-fg', fg);
      document.body.style.background = bg;
    }

    function setPanning(active) {
      state.panning = active;
      document.documentElement.classList.toggle('ca-nube-is-panning', active);
      clearTimeout(panTimer);
      if (active) {
        panTimer = setTimeout(() => setPanning(false), 120);
      }
    }

    function applyRender() {
      state.renderQueued = false;
      const offsetY = activeOffset();
      const offsetX = state.x * layout.viewportW;
      const offsetDeltaY = lastRenderedOffsetY === null ? layout.viewportH : Math.abs(offsetY - lastRenderedOffsetY);
      const offsetDeltaX = lastRenderedOffsetX === null ? layout.viewportW : Math.abs(offsetX - lastRenderedOffsetX);
      const offsetDelta = Math.max(offsetDeltaX, offsetDeltaY);
      const distanceRatio = Math.max(layout.viewportW, layout.viewportH) > 0 ? offsetDelta / Math.max(layout.viewportW, layout.viewportH) : 1;
      const transitionDuration = clamp(0.92 + Math.max(0, distanceRatio - 1) * 0.25, 0.92, 1.32);
      lastRenderedOffsetY = offsetY;
      lastRenderedOffsetX = offsetX;

      document.documentElement.style.setProperty('--ca-nav-x', state.x);
      document.documentElement.style.setProperty('--ca-nav-y', state.y);
      document.documentElement.style.setProperty('--ca-board-transition-duration', `${transitionDuration.toFixed(2)}s`);

      layout.cells.forEach((meta) => {
        const translateX = (meta.x - state.x) * layout.viewportW;
        const translateY = meta.start - offsetY;
        const isActive = meta.x === Math.round(state.x) && meta.y === Math.round(state.y);
        meta.cell.style.setProperty('--ca-cell-height', `${meta.height}px`);
        meta.cell.style.setProperty('--ca-cell-translate-x', `${translateX}px`);
        meta.cell.style.setProperty('--ca-cell-translate-y', `${translateY}px`);
        meta.cell.style.setProperty('--ca-section-scroll-y', isActive ? `${state.sectionScroll}px` : '0px');
        meta.cell.classList.toggle('is-dragging', state.dragging);
      });

      setTheme();
      updateMotionParallax();
    }

    function render() {
      if (state.renderQueued) return;
      state.renderQueued = true;
      window.requestAnimationFrame(applyRender);
    }

    function go(x, y, options = {}) {
      if (usesNativeBoard()) {
        mobileGo(x, y, options.smooth !== false, {
          historyMode: options.history === false ? null : (options.history || 'push'),
          focus: Boolean(options.focus),
          preserveScroll: Boolean(options.preserveScroll)
        });
        return;
      }

      const previousX = Math.round(state.x);
      const previousY = Math.round(state.y);
      const targetX = Math.max(minX(), Math.min(maxX(), Math.round(x)));
      const targetY = Math.max(0, Math.min(maxY(targetX), Math.round(y)));
      const horizontalMove = targetX !== previousX;
      const verticalMove = targetY !== previousY;

      state.x = targetX;
      state.y = targetY;
      state.sectionScroll = horizontalMove || (verticalMove && options.manual) ? 0 : defaultSectionScroll(state.x, state.y);
      state.animating = true;
      setPanning(false);
      clearTimeout(animTimer);
      animTimer = setTimeout(() => { state.animating = false; }, 1500);
      render();
    }

    function scrollActiveSection(deltaY) {
      const meta = activeMeta();
      if (!meta || Math.abs(deltaY) < 2) return false;

      const maxScroll = Math.max(0, meta.height - layout.viewportH);
      if (maxScroll <= 2) return false;
      if (deltaY > 0 && state.sectionScroll >= maxScroll - 2) return false;
      if (deltaY < 0 && state.sectionScroll <= 2) return false;

      state.sectionScroll = clamp(state.sectionScroll + deltaY, 0, maxScroll);
      setPanning(true);
      render();
      return true;
    }

    window.caNubeGo = go;

    let contactHistoryOpen = false;
    function openContactOverlay(pushHistory = true) {
      const overlay = document.querySelector('[data-ca-contact-overlay]');
      if (!overlay) return;
      hideHorizontalHint();
      hideVerticalHint();
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      overlay.scrollTop = 0;
      document.body.classList.add('ca-nube-contact-is-open');
      if (pushHistory && !contactHistoryOpen) {
        window.history.pushState({ caNubeContact: true }, '', '#contacto');
        contactHistoryOpen = true;
      }
    }

    function closeContactOverlay(fromHistory = false) {
      const overlay = document.querySelector('[data-ca-contact-overlay]');
      if (!overlay) return;
      if (!fromHistory && contactHistoryOpen) {
        window.history.back();
        return;
      }
      contactHistoryOpen = false;
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ca-nube-contact-is-open');
      scheduleHorizontalHint();
      scheduleVerticalHint();
    }

    function dismissContactOverlay() {
      const overlay = document.querySelector('[data-ca-contact-overlay]');
      if (!overlay || !overlay.classList.contains('is-open')) return;
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ca-nube-contact-is-open');
      scheduleHorizontalHint();
      scheduleVerticalHint();
      if (contactHistoryOpen) {
        const route = routeFor(state.x, state.y) || routeEntries[0];
        window.history.replaceState({ caNubeRoute: route[0] }, '', `#${route[0]}`);
        lastRouteHash = `#${route[0]}`;
        contactHistoryOpen = false;
      }
    }

    document.addEventListener('click', (event) => {
      const navigationLink = event.target.closest('a[data-ca-go], a[data-ca-contact-open]');
      if (navigationLink && (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) return;
      const hudLogo = event.target.closest('.ca-nube-hud__logo');
      const activeCartDrawer = hudLogo ? document.querySelector('cart-drawer.active') : null;
      if (activeCartDrawer && typeof activeCartDrawer.close === 'function') {
        activeCartDrawer.close();
      }

      const contactOpen = event.target.closest('[data-ca-contact-open]');
      if (contactOpen) {
        event.preventDefault();
        openContactOverlay();
        return;
      }

      const contactClose = event.target.closest('[data-ca-contact-close]');
      if (contactClose) {
        closeContactOverlay();
        return;
      }

      if (event.target.closest('.ca-nube-hud__item, .ca-nube-hud__logo')) {
        dismissContactOverlay();
      }

      const compareTrigger = event.target.closest('[data-ca-compare]');
      if (compareTrigger) {
        const section = compareTrigger.closest('.ca-nube-frente');
        if (!section) return;
        const target = compareTrigger.dataset.caCompare;
        const targetPanel = section.querySelector(`[data-ca-compare-panel="${target}"]`);
        section.querySelectorAll('[data-ca-compare]').forEach((button) => {
          button.classList.toggle('is-active', button === compareTrigger);
        });
        section.querySelectorAll('[data-ca-compare-panel]').forEach((panel) => {
          panel.classList.toggle('is-active', panel.dataset.caComparePanel === target);
        });

        const staticTable = section.querySelector('[data-ca-compare-static]');
        if (!isMobileBoard() && staticTable && targetPanel) {
          const dynamicCells = Array.from(staticTable.querySelectorAll('[data-ca-compare-dynamic]'));
          const sourceCells = Array.from(targetPanel.querySelectorAll('.ca-nube-compare-row > :last-child'));
          const token = (section._caCompareToken || 0) + 1;
          const exitDelay = reduceMotionQuery.matches ? 0 : 130;
          section._caCompareToken = token;
          window.clearTimeout(section._caCompareTimer);

          dynamicCells.forEach((cell) => {
            cell.classList.remove('is-entering');
            cell.classList.add('is-exiting');
          });

          section._caCompareTimer = window.setTimeout(() => {
            if (section._caCompareToken !== token) return;
            dynamicCells.forEach((cell, index) => {
              const source = sourceCells[index];
              if (!source) return;
              cell.textContent = source.textContent;
              if (source.dataset.caCompareAgainst) {
                cell.dataset.caCompareAgainst = source.dataset.caCompareAgainst;
              }
              cell.classList.remove('is-exiting');
              cell.classList.add('is-entering');
            });

            staticTable.offsetWidth;
            dynamicCells.forEach((cell) => cell.classList.remove('is-entering'));
            buildLayout();
          }, exitDelay);
        } else {
          buildLayout();
        }
        return;
      }

      const trigger = event.target.closest('[data-ca-go]');
      if (!trigger) return;
      event.preventDefault();
      const next = trigger.dataset.caGo.split(',').map(Number);
      go(next[0], next[1], { focus: true });
    });

    window.addEventListener('keydown', (event) => {
      if (isCartDrawerInteraction(event)) return;
      if (event.key === 'Escape') {
        const overlay = document.querySelector('[data-ca-contact-overlay].is-open');
        if (overlay) {
          closeContactOverlay();
          return;
        }
      }

      if (state.animating) return;
      const x = Math.round(state.x);
      const y = Math.round(state.y);
      if (usesNativeBoard()) {
        const rightTarget = primaryColumnTarget(x, 1);
        const leftTarget = primaryColumnTarget(x, -1);
        if (event.key === 'ArrowRight' && rightTarget !== null) go(rightTarget, 0, { focus: true, preserveScroll: true });
        if (event.key === 'ArrowLeft' && leftTarget !== null) go(leftTarget, 0, { focus: true, preserveScroll: true });
        if (event.key === 'ArrowDown' && canGoDown(x, y)) go(x, y + 1, { focus: true });
        if (event.key === 'ArrowUp' && canGoUp(x, y)) go(x, y - 1, { focus: true });
        return;
      }

      if (event.key === 'ArrowRight' && x < maxX()) go(x + 1, 0);
      if (event.key === 'ArrowLeft' && x > minX()) go(x - 1, 0);
      if (event.key === 'ArrowDown') {
        if (!scrollActiveSection(layout.viewportH * 0.9) && canGoDown(x, y)) go(x, y + 1, { manual: true });
      }
      if (event.key === 'ArrowUp') {
        if (!scrollActiveSection(layout.viewportH * -0.9) && canGoUp(x, y)) go(x, y - 1, { manual: true });
      }
    });

    function navigateToLocationRoute() {
      const route = routeFromHash();
      if (!route) return;
      if (Math.round(state.x) === route[1] && Math.round(state.y) === route[2]) return;
      mobileGo(route[1], route[2], true, { focus: true });
    }

    window.addEventListener('popstate', () => {
      const overlay = document.querySelector('[data-ca-contact-overlay].is-open');
      if (overlay) closeContactOverlay(true);
      navigateToLocationRoute();
    });

    window.addEventListener('hashchange', navigateToLocationRoute);

    window.addEventListener('wheel', (event) => {
      if (isCartDrawerInteraction(event)) return;

      if (usesNativeBoard()) {
        if (isMobileBoard() || document.querySelector('[data-ca-contact-overlay].is-open')) return;
        const deltaScale = event.deltaMode === 1 ? 16 : (event.deltaMode === 2 ? window.innerWidth : 1);
        const deltaX = (Math.abs(event.deltaX) > 0.5 ? event.deltaX : (event.shiftKey ? event.deltaY : 0)) * deltaScale;
        const deltaY = event.deltaY * deltaScale;
        const horizontalIntent = Math.abs(deltaX) > 1 && Math.abs(deltaX) > Math.abs(deltaY) * 1.12;
        if (!horizontalIntent) return;

        event.preventDefault();
        window.clearTimeout(horizontalGestureTimer);
        horizontalGestureTimer = window.setTimeout(() => {
          horizontalGestureTotal = 0;
        }, 180);

        if (wheelLock) return;
        horizontalGestureTotal += deltaX;
        if (Math.abs(horizontalGestureTotal) < 46) return;

        const direction = horizontalGestureTotal > 0 ? 1 : -1;
        const targetX = primaryColumnTarget(state.x, direction);
        horizontalGestureTotal = 0;
        if (targetX === null) return;

        wheelLock = true;
        window.setTimeout(() => { wheelLock = false; }, 720);
        go(targetX, 0, { history: 'push', preserveScroll: true });
        return;
      }

      if (document.querySelector('[data-ca-contact-overlay].is-open')) {
        return;
      }

      const x = Math.round(state.x);
      const y = Math.round(state.y);
      const hasVerticalAxis = maxY(x) > 0;
      const absX = Math.abs(event.deltaX);
      const absY = Math.abs(event.deltaY);
      const verticalIntent = (absY > 2 && y > 0) || (y === 0 && hasVerticalAxis && absY > absX * 1.5);

      if (verticalIntent) {
        event.preventDefault();
        if (wheelLock || state.animating) return;
        if (scrollActiveSection(event.deltaY)) return;
        if (absY < 28) return;
        wheelLock = true;
        setTimeout(() => { wheelLock = false; }, 980);
        if (event.deltaY > 0 && canGoDown(x, y)) go(x, y + 1, { manual: true });
        if (event.deltaY < 0 && canGoUp(x, y)) go(x, y - 1, { manual: true });
        return;
      }

      const horizontalIntent = y > 0
        ? absX > 64 && absY < 8
        : absX > 42 && absX > absY * 1.85;

      if (horizontalIntent) {
        event.preventDefault();
        if (wheelLock || state.animating) return;
        wheelLock = true;
        setTimeout(() => { wheelLock = false; }, 900);
        if (event.deltaX > 0 && x < maxX()) go(x + 1, 0);
        if (event.deltaX < 0 && x > minX()) go(x - 1, 0);
        return;
      }

      if (y > 0) return;
      event.preventDefault();
      if (wheelLock || state.animating) return;
      const intent = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
      if (Math.abs(intent) < 28) return;
      wheelLock = true;
      setTimeout(() => { wheelLock = false; }, 900);
      if (intent > 0 && x < maxX()) go(x + 1, 0);
      if (intent < 0 && x > minX()) go(x - 1, 0);
    }, { passive: false });

    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(buildLayout, 140);
    });

    const initialRoute = routeFromHash();
    if (initialRoute) {
      state.x = initialRoute[1];
      state.y = initialRoute[2];
      lastRouteHash = `#${initialRoute[0]}`;
    }

    buildLayout();

    const rebuildAfterAssets = () => {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          buildLayout();
          const route = routeFromHash();
          if (route) mobileGo(route[1], route[2], false);
          window.clearTimeout(routeReconcileTimer);
          routeReconcileTimer = window.setTimeout(() => {
            const currentRoute = routeFromHash();
            if (currentRoute) mobileGo(currentRoute[1], currentRoute[2], false);
          }, 260);
        });
      });
    };

    if (document.readyState === 'complete') {
      rebuildAfterAssets();
    } else {
      window.addEventListener('load', rebuildAfterAssets, { once: true });
    }

    if (document.fonts?.ready) {
      document.fonts.ready.then(rebuildAfterAssets);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCaNubeBoard);
  } else {
    initCaNubeBoard();
  }
})();
